import PokeStyle from "Examples/PokeDex/style.module.scss";
import usePokeInfo from "Examples/PokeDex/usePokeInfoCard";
import { Spinner } from "react-bootstrap";

export type PokemonCardProps = {
  id: number;
  name: string;
  onClick?: () => void;
};

const PokemonCard: React.FC<PokemonCardProps> = ({ id, name, onClick }) => {
  const [color, pokeImg, loading] = usePokeInfo(id);

  return (
    <div
      className={`${PokeStyle.borderCard} col p-3`}
      onClick={onClick}
      data-testid='card'>
      <div
        style={{ backgroundColor: color }}
        className={`${PokeStyle.cartaBordeColor}`}>
        <div className={`${PokeStyle.img}`}>
          <div className={`${PokeStyle.cards}`}>
            <div
              className={`${PokeStyle.titulo}`}
              data-testid='nombre-pokemones'>
              <h4>{name.toUpperCase().split("-")[0]}</h4>
            </div>
            <div className={`${PokeStyle.extraimg}`}>
              {loading ? (
                <Spinner animation='border' />
              ) : (
                <img src={pokeImg?.gif || pokeImg?.img} alt='pokeimg' />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PokemonCard;
